export class PropertyAccessorWrapper {
    constructor(obj) {
        this.obj = obj;
    }
    has(prop) {
        if (!prop) {
            return !!this.obj;
        }
        let current = this.obj;
        const parts = this.parts(prop);
        for (let part of parts) {
            if (current === null || typeof current === 'undefined') {
                return false;
            }
            if (!(part in current)) {
                return false;
            }
            current = current[part];
        }
        return true;
    }
    get(prop) {
        if (!prop) {
            return this.obj;
        }
        let current = this.obj;
        const parts = this.parts(prop);
        for (let part of parts) {
            if (current === null || typeof current === 'undefined') {
                return current;
            }
            if (!(part in current)) {
                return null;
            }
            current = current[part];
        }
        return current;
    }
    parts(prop) {
        return prop.split('.');
    }
}
//# sourceMappingURL=accessor.js.map